import React from "react";
import '../../sass/components/flexibleModules/homepage/_components.HomepageHeroSectionWithLogos.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const HeroSectionWithLogos = ({ data }) => {
    return (
        <div className={`cp-homepageHeroSectionWithLogos l-graphicCheck${data.backgroundGraphic}`} style={{ backgroundColor: `${data.backgroundGraphic === 'no' && data.backgroundColor ? data.backgroundColor : ""}` }}>
            <div className="cp-homepageHeroSectionWithLogos__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.heroSectionWithLogosHeader &&
                    <h1 style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }}>{data.heroSectionWithLogosHeader}</h1>
                }
                {data.heroSectionWithLogosTeaser &&
                    <div className="l-teaser" style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }} dangerouslySetInnerHTML={{ __html: data.heroSectionWithLogosTeaser }} />
                }
                {data.heroSectionButtons &&
                    <div className="cp-homepageHeroSectionWithLogos__buttons l--flex">
                        {data.heroSectionButtons.map((buttonItem, index) => (
                            <>
                                {
                                    buttonItem.button.url.substr(-1) !== '/' ?
                                        <a style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }} className={`${index === 1 ? "l-textlink" : "l-button"}`} key={index} href={`${buttonItem.button.url+'/'}`} target={buttonItem.button.target}>
                                            <span dangerouslySetInnerHTML={{ __html: buttonItem.button.title }} />
                                        </a>
                                        :
                                        <a style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }} className={`${index === 1 ? "l-textlink" : "l-button"}`} key={index} href={buttonItem.button.url} target={buttonItem.button.target}>
                                            <span dangerouslySetInnerHTML={{ __html: buttonItem.button.title }} />
                                        </a>
                                }
                            </>
                        ))}
                    </div>
                }
                {data.heroSectionMainImage &&
                    <div className="l--mainImage">
                        {data.heroSectionMainImageLink ?
                            <a href={data.heroSectionMainImageLink.url} target={data.heroSectionMainImageLink.target}>
                                <GatsbyImage image={getImage(data.heroSectionMainImage.gatsbyImage)} alt={data.heroSectionMainImage.altText} />
                            </a>
                            :
                            <GatsbyImage image={getImage(data.heroSectionMainImage.gatsbyImage)} alt={data.heroSectionMainImage.altText} />
                        }
                    </div>
                }
                {data.heroSectionLogos &&
                    <div className="cp-homepageHeroSectionWithLogos__logos l--flex">
                        {data.heroSectionLogos.map((logos, index) => (
                            <div key={index}>
                                {logos.altText ?
                                    <a href={logos.altText}>
                                        <img loading="lazy" key={index} src={logos.sourceUrl} alt={logos.altText} />
                                    </a>
                                    :
                                    <img loading="lazy" key={index} src={logos.sourceUrl} alt={logos.altText} />
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default HeroSectionWithLogos;